import { useTranslation } from "react-i18next";
import { ArrowRight, Bot, Users, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LocalizedLink as Link } from "@/components/routing/LocalizedLink";

export function VelyraHeroSplit({ humansAnchor = "human-coaches" }: { humansAnchor?: string }) {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "en").startsWith("fr") ? "fr" : "en";

  const copy = lang === "fr" ? {
    eyebrow: "— COACHING 1:1",
    headline: "Deux façons d'avoir un meilleur regard sur votre business",
    aiTitle: "Velyra CEO — votre coach IA",
    aiBody: "Bilingue FR/EN. Réponses stratégiques en quelques secondes : pricing, GTM, runway, levée. Aperçu gratuit, sans réservation.",
    aiCta: "Démarrer une session",
    humanTitle: "Travailler avec un coach humain",
    humanBody: "Coachs-opérateurs sélectionnés selon votre stade et vos blocages. Sessions payantes, accompagnement dans la durée.",
    humanCta: "Voir les coachs",
  } : {
    eyebrow: "— 1:1 COACHING",
    headline: "Two ways to get sharper on your business",
    aiTitle: "Velyra CEO — your AI coach",
    aiBody: "Bilingual EN/FR. Strategic answers in seconds — pricing, GTM, runway, fundraising. Free preview, no booking.",
    aiCta: "Start a session",
    humanTitle: "Work with a human coach",
    humanBody: "Operator-coaches matched to your stage and blockers. Paid sessions, deeper engagements.",
    humanCta: "Browse coaches",
  };

  return (
    <section className="mb-10">
      <div className="text-xs font-semibold tracking-widest text-text-2">{copy.eyebrow}</div>
      <h2 className="t-display mt-1 mb-6 text-text-1">{copy.headline}</h2>
      <div className="grid gap-4 md:grid-cols-2">
        <div className="relative overflow-hidden rounded-xl border border-primary/30 bg-gradient-to-br from-primary/10 via-surface-2 to-surface-1 p-6">
          <div className="absolute right-4 top-4 inline-flex items-center gap-1 rounded-full border border-primary/30 bg-surface-1/70 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-primary">
            <Sparkles className="w-3 h-3" /> {lang === "fr" ? "Nouveau" : "New"}
          </div>
          <div className="flex items-center gap-2 mb-2">
            <div className="rounded-md bg-primary/15 p-2 text-primary"><Bot className="w-5 h-5" /></div>
            <h3 className="t-h3 text-text-1">{copy.aiTitle}</h3>
          </div>
          <p className="text-sm text-text-2 mb-4">{copy.aiBody}</p>
          <Button asChild>
            <Link to="/coach">{copy.aiCta} <ArrowRight className="w-4 h-4 ml-1" /></Link>
          </Button>
        </div>
        <div className="rounded-xl border border-border-1 bg-surface-1 p-6">
          <div className="flex items-center gap-2 mb-2">
            <div className="rounded-md bg-surface-2 p-2 text-text-1"><Users className="w-5 h-5" /></div>
            <h3 className="t-h3 text-text-1">{copy.humanTitle}</h3>
          </div>
          <p className="text-sm text-text-2 mb-4">{copy.humanBody}</p>
          <Button asChild variant="outline">
            <a href={`#${humansAnchor}`}>{copy.humanCta} ↓</a>
          </Button>
        </div>
      </div>
    </section>
  );
}